export default "__VITE_PUBLIC_ASSET__6a709563__"